import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import styles from './styles'

const ResourceCard = ({ classes, group, onAction }) => {
  const handleClick = item =>
    onAction(item.action, {
      section: group.id,
      itemId: item.id,
      track: item.track,
    })

  return (
    <section className={classes.root}>
      <h2 className={classes.label}>{group.title}</h2>

      <div className={classes.list}>
        {group.links.map(link => (
          <button
            key={link.id}
            type="button"
            className={classes.link}
            onClick={() => handleClick(link)}
          >
            <span
              className={classes.icon}
              style={{ background: link.tint, color: link.color }}
            >
              <Icon icon={link.icon} className={classes.iconGlyph} />
            </span>
            <span className={classes.linkLabel}>{link.label}</span>
          </button>
        ))}
      </div>

      {group.footerLink && (
        <button
          type="button"
          className={classes.footerLink}
          onClick={() => handleClick(group.footerLink)}
        >
          {group.footerLink.label} →
        </button>
      )}
    </section>
  )
}

export default withStyles(styles)(ResourceCard)
